<template>
  <div class="om-scope om-page">
    <p v-if="state === states.loading" class="om-status">{{ copy.loading }}</p>
    <div v-else-if="state !== states.ready" class="om-card om-status-card">
      <p>{{ state === states.missing ? copy.notAvailable : copy.loadError }}</p>
      <button v-if="state === states.failed" type="button" class="om-button om-button-ghost" @click="load">{{ copy.retry }}</button>
    </div>
    <template v-else>
      <header class="om-card om-hero">
        <p class="om-eyebrow">{{ copy.moduleName }}</p>
        <h1 class="om-hero-title">{{ home.name }}</h1>
        <p class="om-hero-meta">
          <span class="om-version-pill">{{ copy.currentVersion }} {{ version.label }}</span>
          <span>{{ copy.publishedOn }} {{ publishedOn }}</span>
        </p>
        <div class="om-hero-actions">
          <manual-pdf-button :manual-key="manualKey" />
          <router-link class="om-button om-button-ghost" :to="historyRoute">
            <i class="ni ni-archive-2" aria-hidden="true"></i> {{ copy.history }}
          </router-link>
        </div>
      </header>

      <manual-pending-bar compact :manual-key="manualKey" />

      <section class="om-card om-news">
        <h2 class="om-section-title"><i class="ni ni-notification-70" aria-hidden="true"></i> {{ copy.newsTitle }}</h2>
        <ul class="om-news-list">
          <li v-for="line in changeLines" :key="line">{{ line }}</li>
        </ul>
        <p v-if="changedCount" class="om-news-count">{{ changedCount }} {{ copy.changedCount }}</p>
      </section>

      <section class="om-card om-block">
        <manual-search-box :manual-key="manualKey" />
      </section>

      <section class="om-card om-block">
        <h2 class="om-section-title">{{ copy.chaptersTitle }}</h2>
        <manual-chapter-list :manual-key="manualKey" :chapters="home.chapters" />
      </section>

      <manual-pending-bar :manual-key="manualKey" />
    </template>
  </div>
</template>

<script>
import '@/components/OperationsManual/operations-manual.css';
import ManualChapterList from '@/components/OperationsManual/ManualChapterList.vue';
import ManualPdfButton from '@/components/OperationsManual/ManualPdfButton.vue';
import ManualPendingBar from '@/components/OperationsManual/ManualPendingBar.vue';
import ManualSearchBox from '@/components/OperationsManual/ManualSearchBox.vue';
import { CHANGE_STATUS, MANUAL_COPY, MANUAL_ROUTES, changeNoteLines, formatManualDate } from '@/components/OperationsManual/manualCopy';
import manualLoading from './manualLoading';

export default {
  name: 'ManualHome',
  components: { ManualChapterList, ManualPdfButton, ManualPendingBar, ManualSearchBox },
  mixins: [manualLoading],
  data() {
    return { copy: MANUAL_COPY, home: null };
  },
  computed: {
    version() {
      return this.home.current_version;
    },
    publishedOn() {
      return formatManualDate(this.version.published_at);
    },
    changeLines() {
      return changeNoteLines(this.version.change_notes);
    },
    changedCount() {
      return this.home.chapters.filter((chapter) => chapter.change_status !== CHANGE_STATUS.unchanged).length;
    },
    historyRoute() {
      return { name: MANUAL_ROUTES.history, params: { manualKey: this.manualKey } };
    },
  },
  methods: {
    async fetchContent() {
      const home = await this.$store.dispatch('operationsManual/fetchHome', this.manualKey);
      if (!home.current_version) return false;
      this.home = home;
      return true;
    },
  },
};
</script>

<style scoped>
.om-hero { padding: 20px; }
.om-hero-title { font-size: 22px; font-weight: 750; margin: 0 0 8px; line-height: 1.25; color: var(--om-ink); }
.om-hero-meta { display: flex; flex-wrap: wrap; align-items: center; gap: 8px 12px; color: var(--om-muted); font-size: 13.5px; margin: 0 0 16px; }
.om-version-pill { background: var(--om-green-tint); color: var(--om-green-dark); font-weight: 700; padding: 4px 10px; border-radius: 999px; }
.om-hero-actions { display: flex; gap: 10px; flex-wrap: wrap; }
.om-news { padding: 18px 20px; border-color: rgba(93, 188, 133, .45); background: linear-gradient(180deg, rgba(93, 188, 133, .09), var(--om-surface) 70%); }
.om-news-list { margin: 0; padding-left: 20px; line-height: 1.55; }
.om-news-list li { margin-bottom: 6px; }
.om-news-count { margin: 10px 0 0; font-size: 13px; font-weight: 650; color: var(--om-green-dark); }
.om-block { padding: 18px 20px; }
@media (max-width: 576px) {
  .om-hero-actions > * { flex: 1 1 100%; }
}
</style>
